import { useCallback, useEffect } from 'react';
import { getStepConfig } from '../views/getStepConfig';
export const useSidePanelEnterKeyboardSubmit = ({
  isNextButtonEnabled,
  onSubmit,
  currentStep
}) => {
  const handleKeyDown = useCallback(event => {
    if (event.key !== 'Enter' || !isNextButtonEnabled) return;
    const stepConfig = getStepConfig(currentStep);

    // When the submit button is placed outside of the form element and there are multiple inputs within the form, accessibility is lost.
    // Therefore, we need to restore accessibility in this scenario and allow users to submit the step data by pressing the "Enter" key.
    if (!(stepConfig !== null && stepConfig !== void 0 && stepConfig.hasMultipleInputs)) {
      return;
    }
    onSubmit(event);
  }, [isNextButtonEnabled, onSubmit, currentStep]);
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};